<template>
	<v-row no-gutters>
		<v-col cols="6">
			<v-sheet
				color="grey lighten-1"
				elevation="1"
				height="70"
				width="150"
				rounded="xl"
				dark
			>
				<div class="px-5 py-2">
					<small class="pa-0 black--text"
						>{{ $t("label.adults") }}
					</small>
					<p class="headline font-weight-medium">
						{{ reservation.adults }}
					</p>
				</div>
			</v-sheet>
		</v-col>
		<v-col cols="6">
			<v-sheet
				color="grey lighten-1"
				elevation="1"
				height="70"
				width="150"
				rounded="xl"
				dark
			>
				<div class="px-5 py-2">
					<small class="pa-0 black--text"
						>{{ $t("label.children") }}
					</small>
					<p class="headline font-weight-medium">
						{{ reservation.children }}
					</p>
				</div>
			</v-sheet>
		</v-col>
		<v-col cols="6" class="mt-3">
			<small class="pa-0">{{ $t("Date") }} </small>
			<p class="title font-weight-medium">
				{{ reservation.date }}
			</p>
		</v-col>
		<v-col cols="6" class="mt-3">
			<small class="pa-0">{{ $t("Time") }} </small>
			<p class="title font-weight-medium">
				{{ reservation.time }}
			</p>
		</v-col>

		<v-col cols="12" class="mt-3">
			<small class="pa-0">{{ $t("label.comment") }} </small>
			<p class="title font-weight-medium">
				{{ reservation.description }}
			</p>
		</v-col>
	</v-row>
</template>

<script>
export default {
	props: ["reservation"],
};
</script>